import React from 'react';
import { Card, CardBody, Row, Col, Table } from 'reactstrap';
import { Line, Bar } from 'react-chartjs-2';

const PaymentAnalysis = ({ data }) => {
  // Gráfico de ingresos por día
  const dailyRevenueData = {
    labels: data?.dailyRevenue?.map(item => item.date) || [],
    datasets: [
      {
        label: 'Ingresos Diarios',
        data: data?.dailyRevenue?.map(item => item.amount) || [],
        borderColor: '#28a745',
        backgroundColor: 'rgba(40, 167, 69, 0.1)',
        tension: 0.4,
        fill: true
      }
    ]
  };

  // Gráfico de métodos de pago
  const paymentMethodsData = {
    labels: data?.paymentMethods?.map(item => item.method) || [],
    datasets: [
      {
        label: 'Cantidad',
        data: data?.paymentMethods?.map(item => item.count) || [],
        backgroundColor: [
          'rgba(44, 168, 255, 0.8)',
          'rgba(40, 167, 69, 0.8)',
          'rgba(255, 193, 7, 0.8)',
          'rgba(220, 53, 69, 0.8)'
        ],
        borderColor: [
          '#2CA8FF',
          '#28a745',
          '#ffc107',
          '#dc3545'
        ],
        borderWidth: 1
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return 'Q ' + value.toFixed(2);
          }
        }
      }
    }
  };

  return (
    <Row className="mb-4">
      {/* Gráfico de ingresos diarios */}
      <Col lg="8" md="12" className="mb-4">
        <Card style={{ height: '400px' }}>
          <CardBody>
            <h5 className="card-title mb-3">Ingresos por Día (Últimos 30 días)</h5>
            <div style={{ height: '300px' }}>
              <Line data={dailyRevenueData} options={chartOptions} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Gráfico de métodos de pago */}
      <Col lg="4" md="12" className="mb-4">
        <Card style={{ height: '400px' }}>
          <CardBody>
            <h5 className="card-title mb-3">Métodos de Pago</h5>
            <div style={{ height: '300px' }}>
              <Bar data={paymentMethodsData} options={chartOptions} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Tabla de pagos recientes */}
      <Col lg="12" className="mb-4">
        <Card>
          <CardBody>
            <h5 className="card-title mb-3">Pagos Recientes</h5>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Membresía</th>
                  <th>Monto</th>
                  <th>Fecha</th>
                  <th>Método</th>
                  <th>Válido Hasta</th>
                </tr>
              </thead>
              <tbody>
                {data?.recentPayments?.map((payment, index) => (
                  <tr key={index}>
                    <td>
                      <strong>{payment.client_name}</strong>
                    </td>
                    <td>{payment.membership_name}</td>
                    <td>
                      <strong className="text-success">
                        Q {Number(payment.amount || 0).toFixed(2)}
                      </strong>
                    </td>
                    <td>{payment.date_paid}</td>
                    <td>
                      <span className="badge badge-info">
                        {payment.payment_method || 'Efectivo'}
                      </span>
                    </td>
                    <td>
                      <span className="badge badge-success">
                        Válido hasta: {payment.valid_until}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>

      {/* Resumen de ingresos por mes */}
      <Col lg="12" className="mb-4">
        <Card>
          <CardBody>
            <h5 className="card-title mb-3">Resumen de Ingresos por Mes</h5>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Año</th>
                  <th>Mes</th>
                  <th>Total Ingresos</th>
                  <th># Pagos</th>
                  <th>Promedio por Pago</th>
                  <th>Crecimiento</th>
                </tr>
              </thead>
              <tbody>
                {data?.monthlyRevenue?.map((revenue, index) => (
                  <tr key={index}>
                    <td>{revenue.year}</td>
                    <td>{revenue.month_name}</td>
                    <td>
                      <strong className="text-success">
                        Q {Number(revenue.total_amount || 0).toFixed(2)}
                      </strong>
                    </td>
                    <td>
                      <span className="badge badge-primary">
                        {revenue.payment_count || 0}
                      </span>
                    </td>
                    <td>
                      Q {Number(revenue.average_payment || 0).toFixed(2)}
                    </td>
                    <td>
                      <span className={`badge ${
                        revenue.growth > 0 ? 'badge-success' : 
                        revenue.growth < 0 ? 'badge-danger' : 'badge-secondary'
                      }`}>
                        {revenue.growth > 0 ? '+' : ''}{Number(revenue.growth || 0).toFixed(1)}%
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default PaymentAnalysis;
